<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ "Habilitar ficha personal" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  type="date"
                  name="label"
                  label="Fecha Inicio"
                  v-model="form.fecha_inicio"
                  autofocus
                  maxlength="50"
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  type="date"
                  name="label"
                  label="Fecha Fin"
                  v-model="form.fecha_fin"
                  autofocus
                  maxlength="50"
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogHabilitarFicha", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      // this.valid = false
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      let resp_estado = 0;
      let resp_habilita = 0;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          //para habilitar poner en estado creado: 36
          const estado_creado = 36;
          const observacion = null;
          const user = this.$storage.get("user");
          let respuesta_esfich = await this.$service.graphql({
            query: `
          	query{
          	runQuery(consulta:"select persona.fn_estadoficha(${this.form.id_persona}, ${user.id},${estado_creado},${observacion})"){
          		respuesta
          		}
          	}
          `
          });
          resp_estado = respuesta_esfich.runQuery.respuesta[0].fn_estadoficha;
          let respuesta_habilita = await this.$service.graphql({
            query: `
          	query{
          	runQuery(consulta:"select persona.fn_habilitaficha(${this.form.id_persona}, ${user.id},${estado_creado},'${this.form.fecha_inicio}', '${this.form.fecha_fin}')"){
          		respuesta
          		}
          	}
          `
          });
          resp_habilita =
            respuesta_habilita.runQuery.respuesta[0].fn_habilitaficha;
        } catch (error) {
          console.log(error);
        }
        if (resp_estado == 1 && resp_habilita == 1) {
          this.$message.success();
        } else {
          this.$message.error();
        }
        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/v_listaficha/dialogs/HabiltarListaFicha.vue